// Minimal JavaScript - Only for updating links and selected class
// Image switching is handled purely by CSS, so this is just for UX enhancement

class MinimalSwatchEnhancer {
  constructor() {
    this.init();
  }

  init() {
    // Listen for radio input changes (triggered by label clicks)
    document.addEventListener('change', (e) => {
      if (e.target.classList.contains('xo-product-card__color-input')) {
        const radio = e.target;
        const productCard = radio.closest('xo-product');
        const variantId = radio.getAttribute('data-variant-id');
        
        if (productCard && variantId) {
          this.updateSelectedClass(productCard, variantId);
          this.updateLinks(productCard, variantId);
        }
      }
    });
  }

  updateSelectedClass(productCard, variantId) {
    // Remove all selected classes
    const allSwatches = productCard.querySelectorAll('.xo-product-card__color-swatch');
    allSwatches.forEach(s => s.classList.remove('is-selected'));
    
    // Add selected class to current swatch
    const currentSwatch = productCard.querySelector(
      `.xo-product-card__color-swatch[data-variant-id="${variantId}"]`
    );
    if (currentSwatch) {
      currentSwatch.classList.add('is-selected');
    }
  }

  updateLinks(productCard, variantId) {
    // Update product card attribute
    productCard.setAttribute('xo-selected-or-first-available-variant-id', variantId);
    
    // Get variant URL from the swatch
    const currentSwatch = productCard.querySelector(
      `.xo-product-card__color-swatch[data-variant-id="${variantId}"]`
    );
    
    if (!currentSwatch) return;
    
    const variantUrl = currentSwatch.getAttribute('data-variant-url');
    if (!variantUrl) return;

    const baseUrl = variantUrl.split('?')[0];
    const fullUrl = `${baseUrl}?variant=${variantId}`;

    // Update title link
    const titleLink = productCard.querySelector('.xo-product-card__title-link');
    if (titleLink) titleLink.href = fullUrl;

    // Update image link
    const imageLink = productCard.querySelector('.xo-product-card__image-link');
    if (imageLink) imageLink.href = fullUrl;

    // Update quick view triggers
    const quickViewTriggers = productCard.querySelectorAll('.xo-product-card__quick-view-trigger');
    quickViewTriggers.forEach(trigger => {
      const currentUrl = trigger.getAttribute('xo-product-url');
      if (currentUrl) {
        const urlBase = currentUrl.split('?')[0];
        trigger.setAttribute('xo-product-url', 
          `${urlBase}?variant=${variantId}&section_id=quick-view-content`
        );
      }
    });

    // Dispatch event for other scripts
    productCard.dispatchEvent(new CustomEvent('variant:changed', {
      detail: { variantId, variantUrl },
      bubbles: true
    }));
  }
}

// Initialize
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new MinimalSwatchEnhancer();
  });
} else {
  new MinimalSwatchEnhancer();
}